import axios from '@/jslib/axios'

export const saveMotorQuotation = data => {
  return axios({
    method: 'post',
    url: '/api/quotation/motors',
    data
  })
}
